import React from "react";
import Header from "../../../widgets/Header";
import Footer from "../../../widgets/Footer";
import "./Layout.scss";

const Layout = ({ children }) => {
  return (
    <div className="layout">
      {/* Skip to main content link for keyboard users */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <Header />

      <main
        id="main-content"
        className="layout__main"
        role="main"
        tabIndex="-1"
      >
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
